import axios from "axios";

import type { AllInputData } from "../config/types/context.types";
import type { DataRequested } from "../types/app.types";

const getDataFromDB = async ({
  dataRequested,
}: {
  dataRequested: DataRequested;
}): Promise<AllInputData> => {
  console.log("DB START");

  const api = `${process.env.REACT_APP_SERVER_IP}/api?country=${dataRequested.country}&year=${dataRequested.year}`;
  const res = await axios.get(api);
  console.log("DB COMPLETE", res.data);
  // axios returns `any` for response data; cast at the boundary.
  return res.data as AllInputData;
};

export default getDataFromDB;
